import script from "./InvoiceGenerationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceGenerationModal.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceGenerationModal.vue?vue&type=style&index=0&id=ab4f2732&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab4f2732"]])

export default __exports__